export const OFFERING_CONSTANTS = {
  title: "See What We Can Do for You",
  subTitle:
    "Join our growing network of successful, secure, and future-ready organizations.",
  text: "Explore how OneMind Services has transformed businesses like yours — and imagine what we could achieve together. Discover success stories, industry-specific solutions, and the outcomes we deliver.",
  btnText: "Book Your Free Consultation",
};
